function Card(results) {
	return `
	<article class="article group article-feed">
		<div class="article-insert">
			<span class="article-insert-details">
				<span class="article-title group-hover:text-link-underline-hovered">
				No results found${ 
					results.query && ` for <q>${results.query}</q>`
				}
				</span>
			</span>
		</div>
	</article>
	`;
}

export default Card;
